import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { LOGO_URL } from "@/data/news";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(apiErr(e2.response?.data?.detail) || "लॉगिन विफल");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0F1E] flex items-center justify-center px-4 font-sans-dev relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="relative w-full max-w-[420px]">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="Denva Post" className="h-12 w-auto mb-4" />
          <h1 className="text-white font-serif-dev text-2xl font-bold">कंटेंट डैशबोर्ड</h1>
          <p className="text-white/50 text-sm mt-1">Denva Post · Admin Console</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-xl p-7 shadow-2xl">
          <label className="block mb-4">
            <span className="text-[11px] uppercase tracking-[0.2em] text-gray-500">ईमेल</span>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-1 w-full border-b-2 border-gray-200 focus:border-[#D92525] outline-none py-2 text-[16px]" placeholder="you@denvapost.com" />
          </label>
          <label className="block mb-6">
            <span className="text-[11px] uppercase tracking-[0.2em] text-gray-500">पासवर्ड</span>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-1 w-full border-b-2 border-gray-200 focus:border-[#D92525] outline-none py-2 text-[16px]" placeholder="••••••••" />
          </label>
          {err && <div data-testid="login-error" className="mb-4 text-sm text-[#D92525] bg-red-50 rounded px-3 py-2">{err}</div>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-[#0A0F1E] hover:bg-[#D92525] transition-colors text-white rounded-lg py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />} लॉगिन करें
          </button>
        </form>
        <p className="text-center text-white/30 text-xs mt-6">© 2026 Denwa News · केवल अधिकृत सदस्य</p>
      </div>
    </div>
  );
}
